export enum PushEventTypesEnum {
  JOB_UPDATED = 'job_updated',
  TAGS_UPDATED_BATCH = 'tags_updated_batch',
  TAGS_DELETED_BATCH = 'tags_deleted_batch',
  LMS_COURSE_COMPLETED = 'lms_course_completed',
  AI_TAGGING_SAMPLE_APPROVED = 'ai_tagging_sample_approved',
}

export const directPrecogsUpdatedEventName = 'direct_conversation_precog_updated';
export const directPrecogsDeletedEventName = 'direct_conversation_precog_deleted';

export function getConversationRoomName(conversationId: number): string {
  return `conversation-${conversationId}`;
}
